<app-dialog-header [title]="'GENERAL.PROPERTY.FILTER_BY'" (onClick)="cancel()"></app-dialog-header>

<div mat-dialog-content class="filter-by-dialog-content p-24" [class.overflow-y-visible-override]="isSelectedDateRangeFilter">
    <div class="filter-by-dialog-body">
        <div class="filter-by-dialog-split">
            <div class="filter-by-dialog-categories">
                <button
                    type="button"
                    class="filter-by-dialog-category"
                    *ngFor="let item of filters; trackBy: trackFilterCategory"
                    [class.filter-by-dialog-category-selected]="selectedFilter.value?.name === item.name"
                    (click)="selectFilterCategory(item)"
                >
                    <span class="filter-by-dialog-category-label">{{ item.translationKey | translate }}</span>
                    <span *ngIf="filterCategoryCounts[item.name]" class="filter-by-dialog-category-count">{{ filterCategoryCounts[item.name] }}</span>
                </button>
            </div>

            <div class="filter-by-dialog-options">
                <div class="filter-by-dialog-filter-surface p-24" [ngSwitch]="selectedFilter.value?.name">
                    <app-certificates-status-filter *ngSwitchCase="'Status'" [statuses]="statuses" (addedToList)="addToList($event)"></app-certificates-status-filter>
                    <app-certifications-filter
                        *ngSwitchCase="'Certifications'"
                        [certificationProviders$]="certificationProviders$"
                        (addedToList)="addToList($event)"
                    ></app-certifications-filter>
                    <app-certificate-date-filter
                        *ngSwitchCase="'IssueDate'"
                        [type]="'IssueDate'"
                        [afterText]="'PAGE.CERTIFICATIONS.LABEL.SHOW_CERTIFICATES_ISSUED_AFTER'"
                        [beforeText]="'PAGE.CERTIFICATIONS.LABEL.SHOW_CERTIFICATES_ISSUED_BEFORE'"
                        (addedToList)="addToList($event)"
                    ></app-certificate-date-filter>
                    <app-certificate-date-filter
                        *ngSwitchCase="'ExpirationDate'"
                        [type]="'ExpirationDate'"
                        [afterText]="'PAGE.CERTIFICATIONS.LABEL.SHOW_CERTIFICATES_EXPIRED_AFTER'"
                        [beforeText]="'PAGE.CERTIFICATIONS.LABEL.SHOW_CERTIFICATES_EXPIRED_BEFORE'"
                        (addedToList)="addToList($event)"
                    ></app-certificate-date-filter>
                    <app-certificates-teams-filter *ngSwitchCase="'Teams'" [teamId]="teamId" (addedToList)="addToList($event)"></app-certificates-teams-filter>
                    <app-certificates-users-filter *ngSwitchCase="'Users'" [users$]="users$" (addedToList)="addToList($event)"></app-certificates-users-filter>
                    <app-certificates-team-members-filter
                        *ngSwitchCase="'TeamMembers'"
                        [teamMembers$]="teamMembers$"
                        [teamId]="teamId"
                        [includeSubteams]="includeSubteams"
                        (addedToList)="addToList($event)"
                    ></app-certificates-team-members-filter>
                </div>
            </div>
        </div>
    </div>
</div>

<div mat-dialog-actions class="filter-by-dialog-actions">
    <div *ngIf="selectedFiltersGroups.length" class="filter-by-dialog-active-filters bg-gray-100 rounded px-16 py-12">
        <div class="flex flex-col gap-2">
            <div *ngFor="let group of selectedFiltersGroups; trackBy: trackSelectedFilterGroup" class="flex flex-row flex-wrap items-center gap-2">
                <span class="shrink-0 whitespace-nowrap text-xs font-semibold leading-5 text-darktextcolor">
                    {{ group.categoryLabel }} ({{ group.chips.length }}):
                </span>
                <span
                    *ngFor="let chip of group.chips; trackBy: trackSelectedFilterChip"
                    class="filter-active-chip box-border inline-flex h-6 max-w-full shrink-0 items-center rounded-full py-0 pl-3 pr-1 text-xs leading-none text-white"
                    [style.background-color]="group.color"
                >
                    <span class="max-w-[240px] overflow-hidden text-ellipsis whitespace-nowrap">{{ chip.chipLabel }}</span>
                    <button
                        *ngIf="removable"
                        type="button"
                        class="filter-chip-remove"
                        [attr.aria-label]="'GENERAL.BUTTON.REMOVE' | translate"
                        (click)="removeFilterChip(chip)"
                    >
                        <mat-icon>close</mat-icon>
                    </button>
                </span>
            </div>
        </div>
    </div>

    <div class="filter-by-dialog-action-buttons">
        <app-white-button [label]="'GENERAL.LABEL.CLEAR_ALL'" [disabled]="!list.length" (onClick)="clearFilters()"></app-white-button>

        <div class="flex items-center">
            <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="cancel()"></app-white-button>
            <app-flat-button [label]="'GENERAL.BUTTON.SAVE'" (onClick)="save()"></app-flat-button>
        </div>
    </div>
</div>
